<template>
  <div
    class="video-container"
    ref="container"
    @mouseover="mouseOver"
    @click="videoSwitch"
  >
    <div v-show="paused" class="mask-container">
      <div class="icon small"></div>
    </div>
    <video preload :poster="poster" ref="video" :src="src"></video>
  </div>
</template>

<script>
export default {
  name: "MediaVideoComponent",
  props: {
    src: {
      // 视频地址
      type: String,
      required: true,
    },
    poster: {
      // 下载时显示的图像
      type: String,
      required: true,
    },
  },
  data() {
    return {
      paused: false,
      iconSmall: false, // 是否显示小的播放按钮，播放按钮为图片大小的65%,但是如果65%超过150px则显示150px。
    };
  },
  methods: {
    /**
     * 鼠标划过
     */
    mouseOver() {
      this.paused = this.$refs.video.paused;
    },
    /**
     * 切换视频模式(播放 暂停)
     */
    videoSwitch() {
      const video = this.$refs.video;
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
      this.paused = video.paused;
    },
    /**
     * 关闭
     */
    pause() {
      this.$refs.video.pause();
    },
  },
  beforeDestroy() {
    this.pause();
  },
  mounted() {
    this.iconSmall = this.$refs.container.clientHeight * 0.65 > 150;
  },
};
</script>

<style lang="less" scoped>
.video-container {
  width: 100%;
  height: 100%;
  position: relative;
  cursor: pointer;
  z-index: 301;
  display: flex;
  align-items: center;
  justify-content: center;
  video {
    width: 100%;
    height: 100%;
  }
  .mask-container {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    display: flex;
    background: rgba(255, 255, 255, 0.1);
    align-items: center;
    justify-content: center;
    .icon {
      width: 65%;
      padding-bottom: 65%;
      z-index: 2;
      background-size: cover;
      background-image: url("../../../../public/images/schedule_posts/list/video.png");
      &.small {
        width: 100px;
        height: 100px;
        padding-bottom: inherit;
      }
    }
  }
}
</style>
